import { render, staticRenderFns } from "./KnowledgeContentCopyView.vue?vue&type=template&id=9e0382c6&"
import script from "./KnowledgeContentCopyView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentCopyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports